import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import App from "./App";
import BackDrop from "./components/backDrop/BackDrop";
import ErrorBoundary from "./components/errorBoundary/ErrorBoundary";
import { BrowserRouter } from "react-router-dom";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import axios from "axios";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import PwaPage from "./PwaPage";
import "./tailwind.css";
const root = ReactDOM.createRoot(document.getElementById("root"));
axios.defaults.baseURL = process.env.REACT_APP_API_URL;
i18next
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ["en", "fa", "ar"],
    fallbackLng: process.env.REACT_APP_LANGUAGE,
    debug: false,

    // Options for language detector
    detection: {
      order: ["localStorage"],
      caches: ["localStorage"],
    },
    react: {
      useSuspense: false,
      bindI18n: "loaded languageChanged",
      bindI18nStore: "added",
    },
    backend: {
      loadPath: `/assets/locales/{{lng}}/translation.json?time=${new Date().getTime()}`,
    },
  });

root.render(
  <ErrorBoundary>
    <Suspense fallback={<BackDrop open={true} />}>
      <BrowserRouter>
        <DndProvider backend={HTML5Backend}>
          <PwaPage>
            <App />
          </PwaPage>
        </DndProvider>
      </BrowserRouter>
    </Suspense>
  </ErrorBoundary>,
);
serviceWorkerRegistration.register();
